// ABOUTME: Resolves the image URL a catalog product card should render, or undefined when there is none.
// ABOUTME: The catalog payload carries an empty url for models without an image content.

import type { IProduct } from '@coolshop/cool-model-selection';

/**
 * Returns the usable image URL of a catalog product. `image` is nullable and the server sends
 * `url: ''` for a model with no image content, so both cases collapse to `undefined` and the card
 * renders its placeholder instead.
 */
export function getProductImageUrl(product: Pick<IProduct, 'image'>): string | undefined {
    const url = product.image?.url?.trim();
    return url || undefined;
}
